<template>
  <div class="config">
    <!-- <p>Nhóm lớp: {{ marksheetData.student_groups.map(i => i.text).join(',') }}</p> -->
    <p>Học kỳ ({{ semesterConfigs.length }})</p>
    <div class="semester-configs">
      <SemesterDetail
        v-for="(s, index) in semesterConfigs"
        :key="s.id"
        :index="index"
        :semesterId="s.id"
        :semester="s"
        :courseConfigs="s.semester_course_configs"
      >
      </SemesterDetail>
    </div>
    <div class="toolbar d-flex-align-center">
      <v-btn elevation="0" color="primary" @click="onClickUpsertSemester()">
        Thêm học kỳ <v-icon right> mdi-plus </v-icon>
      </v-btn>
    </div>
    <BaseDialog
      v-if="upsertSemesterConfigDialog.isOpen"
      :isOpen="upsertSemesterConfigDialog.isOpen"
      :title="upsertSemesterConfigDialog.title"
      @close="upsertSemesterConfigDialog.isOpen = false"
      @cancel="upsertSemesterConfigDialog.onCancel"
      @confirm="upsertSemesterConfigDialog.callback"
    >
      <v-form lazy ref="semesterForm" @submit.prevent="upsertSemesterConfigDialog.callback()">
        <v-card-text v-if="upsertSemesterConfigDialog.currentItem" class="pa-4">
          <v-text-field
            v-model="upsertSemesterConfigDialog.currentItem.title"
            label="Tiêu đề"
            required
            class="mb-3"
            hide-details="auto"
            :rules="[$rules.required]"
          ></v-text-field>
        </v-card-text>
      </v-form>
    </BaseDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BaseDialog from '@/components/base/BaseDialog'

import { cloneDeep } from 'lodash'
import SemesterDetail from './SemesterDetail.vue'
export default {
  components: {
    SemesterDetail,
    BaseDialog
  },
  data() {
    return {
      tabIndex: 0,
      upsertMarkSheetDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        onCancel: () => {
          this.upsertMarkSheetDialog.isOpen = false
        },
        callback: () => {}
      },
      upsertSemesterConfigDialog: {
        isOpen: false,
        title: '',
        currentItem: null,
        callback: null,
        onCancel: () => {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      }
    }
  },
  methods: {
    ...mapActions('marksheet', [
      'fetchOverallMarkSheet',
      'fetchSemesterConfigs',
      'createSemesterConfig',
      'updateSemesterConfig',
      'updateOverallMarkSheet',
      'createOverallMarkSheet'
    ]),
    ...mapActions('studentGroup', ['fetchStudentGroups']),
    onClickUpsertMarkSheet(item) {
      this.upsertMarkSheetDialog.currentItem = cloneDeep(item) || {
        title: 'Bảng điểm số ' + (this.tableData.length + 1),
        student_groups: []
      }
      this.upsertMarkSheetDialog.title = item ? 'Sửa bảng điểm' : 'Tạo bảng điểm'
      this.upsertMarkSheetDialog.isOpen = true
      this.upsertMarkSheetDialog.callback = (async () => {
        try {
          if (item) {
            await this.updateOverallMarkSheet(this.upsertMarkSheetDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createOverallMarkSheet({ data: this.upsertMarkSheetDialog.currentItem })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertMarkSheetDialog.isOpen = false
        }
      }).bind(this)
    },
    onClickUpsertSemester(item) {
      this.upsertSemesterConfigDialog.isOpen = true
      this.upsertSemesterConfigDialog.title = item ? 'Sửa cấu hình học kỳ' : 'Tạo học kỳ mới'
      this.upsertSemesterConfigDialog.currentItem = item
        ? cloneDeep(item)
        : {
            title: `Học kỳ ` + (this.semesterConfigs.length + 1),
            overall_mark_sheet: this.$route.params.id
          }
      this.upsertSemesterConfigDialog.callback = async () => {
        if (!this.$refs.semesterForm.validate()) {
          return
        }
        try {
          if (item) {
            await this.updateSemesterConfig(this.upsertSemesterConfigDialog.currentItem)
            this.$alert.success('Cập nhật thành công')
          } else {
            await this.createSemesterConfig({ data: this.upsertSemesterConfigDialog.currentItem })
            this.$alert.success('Tạo thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertSemesterConfigDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapState('marksheet', ['overallMarkSheets', 'semesterConfigs', 'semesterCourseConfigs']),
    ...mapState('studentGroup', ['studentGroups']),
    marksheetData() {
      return this.overallMarkSheets.find(i => i.id === this.$route.params.id)
    },
    marksheetDetailLink() {
      return [
        {
          to: `/mark-sheets/`,
          text: 'Bảng điểm'
        },
        {
          to: `/mark-sheets/${this.$route.params.id}/`,
          text: (this.marksheetData || {}).title
        }
      ]
    }
  },
  created() {
    this.fetchOverallMarkSheet({ marksheetId: this.$route.params.id })
    this.fetchSemesterConfigs({ marksheetId: this.$route.params.id })
    this.fetchStudentGroups()
  }
}
</script>
<style scoped>
.semester-configs {
  margin-bottom: 20px;
}
</style>
